import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import './components/shell.wc';
import './styles/global.css';

@customElement('app-index')
export class AppIndex extends LitElement {
  static styles = css`
    :host {
      display: block;
      width: 100vw;
      height: 100vh;
    }
  `;

  render() {
    return html`<vt-shell></vt-shell>`;
  }
}
